module.exports = __webpack_public_path__ + "img/iluks_logo_white_big.9eead4b6.png";